/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Button } from "@mui/material";

const WebpageDisplayComponent = (props) => {
    
    const { onChange, onRemove, webpage } = props;
    
    return (
        <div
            style={{
                border: "1px solid #c4c4c4",
                borderRadius: "8px",
                backgroundColor: "#f4f4f4",
                width: "100%",
                height: "70px",
                padding: "12px",
            }}
        >
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "12px",
                }}
            >
                <div style={{ flexGrow: 1 }}>
                    <div>{webpage.nav_title}</div>
                </div>
                <Button variant='outlined'>
                    Hide
                </Button>
                <Button variant='outlined' onClick={() => onRemove(webpage)}>
                    Remove
                </Button>
                <Button variant='contained' onClick={() => onChange(webpage)}>
                    Change
                </Button>
            </div>
        </div>
    );
};

export { WebpageDisplayComponent };
